import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';

/**
 * CarouselSlidesWrapper is the component that it only focus
 * is to wrap the slides. This is not the concern of CarouselContainer
 * to allow adding other components to the carousel.
 */
@Component({
	selector: 'carousel-slides-wrapper',
	templateUrl: './carousel-slides-wrapper.component.html',
	styleUrls: ['./carousel-slides-wrapper.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
})
export class CarouselSlidesWrapperComponent {
	@ViewChild('slider')
	private sliderRef!: ElementRef<HTMLDivElement>;

	public get slider(): HTMLDivElement {
		return this.sliderRef.nativeElement;
	}
}
